<template>
  <div>
    <!-- <v-card-title class="headline ml-3 mt-3 mb-0"><h4>Exhibition History</h4></v-card-title> -->
    <v-card-text>

      <v-layout row justify-center>
        <v-dialog v-model="dialog" max-width="290">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this exhibition?</v-card-title>
            <v-card-text>
              This Exhibition will be deleted from all artworks.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" flat="flat" @click="dialog = false">
                No
              </v-btn>

              <v-btn v-if="c_user.delete_rights" color="green darken-1" flat="flat" @click="deleteExhibition">
                Yes
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <new-exhibition-history v-if="show_form" @show_form="show_form=$event" loan='1'></new-exhibition-history>

      <v-flex xs12>
        <v-switch v-model="view" label="Advanced" value="advanced" v-if="this.exhibitions.length>0" color="black"></v-switch>
        <v-btn fab dark color="grey" class="right small" outline @click="show_form=true" v-if="show_form==false">
          <v-icon dark>add</v-icon>
        </v-btn>
      </v-flex>

      <h3 v-if="this.exhibitions.length==0" class='pl-4'>No Loans for this artwork yet.</h3>
    
      <v-container fluid grid-list-md v-if="this.exhibitions">

        <v-data-iterator  v-if="this.exhibitions.length>0"
          :items="exhibitions"
          content-tag="v-layout" row wrap hide-actions

        >
          <v-flex
            slot="item"
            slot-scope="props"
            xs12 sm12 md6 lg6
          >
            <v-card v-if="view=='advanced'">
              <v-card-title><h4>{{props.item.show_type == 0 ? "Solo show" : "Group show" }}: {{ props.item.title }}</h4></v-card-title>
              <v-divider></v-divider>
              <v-list >
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.institution }} {{ props.item.city }} {{ props.item.country }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.duration_start }} - {{ props.item.duration_end }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>

            <v-card v-if="view!='advanced'">
              <v-card-title><h4>{{props.item.show_type == 0 ? "Solo show" : "Group show" }}: {{ props.item.title }}</h4></v-card-title>
              <v-divider></v-divider>
              <v-list >
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.institution }}, {{ props.item.city }}, {{ props.item.country }} </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-data-iterator>

      </v-container>
    </v-card-text>
  </div>
</template>

<script>
  import NewExhibitionHistory from '@/components/artworks/NewExhibitionHistory'
  export default {
    props: ['artwork'],
    data: () => ({
      view: 'advanced',
      show_form: false,
      dialog: false,
      show: true,
      // exhibitions: this.exhibitions2
    }),
    // created () {
    //   this.reset_view()
    // },
    methods: {
      deleteExhibition (e) {
        // var index = exhibition_artworks.indexOf(e);
        // console.log('index = ' + index)
        // exhibition_artworks.splice(index,1)
        this.$store.dispatch('deleteExhibition',e)
        this.dialog = false
      }
      // reset_view () {
      //   var ee = this.store_e
      //   this.exhibitions = this.exhibitions2
      //   // console.log('reset_view')
      //   // console.log(this.exhibitions2)
      // }
    },
    computed: {
      store_e () {
        // console.log('store_e')
        return this.$store.state.exhibitions
      },
      exhibitions () {
        // console.log('exa')
        var out = this.store_e.filter(t => {
          return t.artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
        })
        var out = out.filter(e => {
          return e.loan == 1
        })
        return out
      }
    },
    components: {NewExhibitionHistory}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artworks/LoanHistory.vue